import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback, useEffect } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import AccordionAccountholderForm from './form';
import { AccordionAccountholderFormVM } from 'front-office/view-models/certificate/accountholder-form';
import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';
import { useAccountHolder } from 'front-office/hooks/storage';

interface AccountholderProps {
  disabled?: boolean;
  isHistorical?: boolean;
}

const AccountholderComponent = ({
  disabled,
  isHistorical,
}: AccountholderProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CommonRequestCertificateInterface>();

  const accountHolderContext = useAccountHolder();

  useEffect(() => {
    formContext.setFieldValue('accountholder', accountHolderContext.values?.accountholder);
  }, []);

  useEffect(() => {
    accountHolderContext.setValues({
      accountholder: formContext.values.accountholder,
    });
  }, [formContext.values.accountholder]);

  const onFieldAccountholderChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('accountholder', {
        ...formContext.values.accountholder,
        [key]: value,
      });
    },
    [formContext.values.accountholder, formContext.setFieldValue]
  );

  const onFieldsAccountholderChange = useCallback(
    (values) => {
      formContext.setFieldValue('accountholder', {
        ...formContext.values.accountholder,
        ...(values || {}),
      });
    },
    [formContext.values.accountholder, formContext.setFieldValue]
  );

  useEffect(() => {
    if (formContext?.values?.certificateInternOnly && !disabled) {
      formContext.setFieldValue('accountholder', {
        ...formContext.values,
        accountholder: {
          ...formContext.values.accountholder,
          sameApplicant: false,
        },
      });
      setOpen(true);
    }
  }, [formContext?.values?.certificateInternOnly, disabled]);
  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-certificate-accountholder-content"
        id="panel-certificate-accountholder-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Intestatario</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionAccountholderForm
          disabled={disabled}
          values={formContext.values.accountholder}
          isHistorical={isHistorical}
          onChange={onFieldAccountholderChange}
          onChangeValues={onFieldsAccountholderChange}
          errors={formContext.errors.accountholder as FormikErrors<AccordionAccountholderFormVM>}
          touched={
            formContext.touched
              .accountholder as unknown as FormikTouched<AccordionAccountholderFormVM>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccountholderComponent.displayName = 'Accordion accountholder component';

const Accountholder = memo(AccountholderComponent);

export default Accountholder;
